
export function initPageSidebar( $pageSidebar, $targetEntities = null ){
    
    $pageSidebar = $( $pageSidebar );
    
    if ( $targetEntities === null ){
        $targetEntities = $( '.page-sidebar-anchor-target' );
    } else {
        $targetEntities = $( $targetEntities );
    }
    
    var htmlTargetEntities = $targetEntities.get();
    
    if ( htmlTargetEntities.length ){
        
        const windowHeight = window.innerHeight;
        // TODOUI make this better. 80 is header height. Get this from element.
        // replace 80px on top with this value too.
        const bottomMargin = windowHeight - 80 - 50;
        
        const observerOptions = {
            
            rootMargin: "80px 0px -" + bottomMargin + "px 0px"
        };
        
        const observerCallback = (entries) => {
            entries.forEach((entry) => {

                if ( entry.isIntersecting ){
                    // TODOUI have page sidebar function for modifying link etc
                    $pageSidebar.find( 'li' ).removeClass( 'active' );
                    var $link = $pageSidebar.find( 'a[href="#' + $( entry.target ).attr( 'id' ) + '"]');
                    $link.closest( 'li' ).addClass( 'active' );
                }

                // TODOUI fix the bobbins implementation above. It's a basic proof of concept,
                // not a production ready item yet. The margin is not correct and the active switching
                // doesn't always work. Property create e.g. structure/compliance is never highlighted
            });
        }
        
        const observer = new IntersectionObserver( observerCallback, observerOptions );
        
        htmlTargetEntities.forEach((el) => {
            observer.observe( el );
        });
        
    }
    
}
